import { Component, OnInit } from "@angular/core";
import { Globals } from "../globals";
import { Router, ActivatedRoute } from "@angular/router";
import { ProfileServices } from "../services/profile.service";

@Component({
  selector: "app-forget-password",
  templateUrl: "./forget-password.component.html",
  styleUrls: ["./forget-password.component.css"],
})
export class ForgetPasswordComponent implements OnInit {
  loading = false;
  submitted = false;
  userName = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private globals: Globals,
    private ProfileServices: ProfileServices
  ) { }

  ngOnInit(): void { }

  Submit() {
    this.ProfileServices.forgetPass(this.userName).subscribe((result) => {
      this.router.navigate(["login"]);
      this.globals.presentSuccessToast("An email has been sent to your registered email, please check and follow the instructions");
    });
  }
}
